import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { ToastContainer } from 'react-toastify'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import AssignmentIcon from '@material-ui/icons/Assignment'
import { TABLE_CARTAS_DE_PORTE_VETADAS } from '../../../config/tables'
import * as actions from '../actions'
import { FORM_CARTAS_DE_PORTE_VETADAS } from '../../../config/forms'
import { INTERVALO_CORTO, INTERVALO } from '../../../config/settings'
import { saveAs } from 'file-saver'
import moment from 'moment'
import DescargaPdf from '../../PdfDownload/container/DescargaPdf'

class CartasDePorteVetadas extends Component {
  constructor (props) {
    super(props)
    this.verDetalle = this.verDetalle.bind(this)
    this.descargarPdf = this.descargarPdf.bind(this)
    this.generarPdf = this.generarPdf.bind(this)
    this.COLUMNS = [
      {
        name: 'numero',
        label: 'CTGE',
        options: {
          filter: false,
          sort: true
        }
      },
      {
        name: 'fechaCupo',
        label: 'Fecha Cupo',
        options: {
          filter: true,
          sort: true,
          filterType: 'multiselect',
          customBodyRender: f => {
            moment.locale('ar-AR')
            return <div>{f ? moment(f).format('L') : null }</div>
          }
        }
      },
      {
        name: 'cereal',
        label: 'Cereal',
        options: {
          sort: false,
          filter: true,
          filterType: 'checkbox',
          filterList: this.props.filtroInicial ? this.props.filtroInicial : [],
          customBodyRender: (c) => { return c ? c.trim() : null }
        }
      },
      {
        name: 'codigoCupo',
        label: 'Codigo de Cupo',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'exportador',
        label: 'Exportador',
        options: {
          filter: true,
          sort: true,
          filterType: 'multiselect'
        }
      },
      {
        name: 'error',
        label: 'Error',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'detalle',
        label: 'Operaciones',
        options: {
          print: false,
          filter: false,
          sort: false,
          viewColumns: false,
          customBodyRender: detalle => {
            // La url deberia definirse con REACT_APP_PDF_URL
            // const urlPdf = `http://panda.terminalquequen.com.ar/laridae/pdf/${detalle.numero}.pdf`
            const urlPdf = `${process.env.REACT_APP_PDF_URL}${detalle.numero}.pdf`
            return (<div>
              <Tooltip title={'Ver los detalles...'}>
                <IconButton onClick={() => this.verDetalle(detalle)}>
                  <AssignmentIcon fontSize='default' color='primary' />
                </IconButton>
              </Tooltip>
              <Tooltip title={'Descargar PDF desde ARCA'}>
                <DescargaPdf url={urlPdf} filename={detalle.numero} />
              </Tooltip>
            </div>)
          }
        }
      }
    ]
  }

  verDetalle (detalle) {
    this.props.openDialogDetalles(detalle)
  }

  descargarPdf (detalle) {
    this.props.actualizarDetalles(detalle)
    this.props.obtenerDetalleCartaDePorteVetada(this.props.descargarDetallesPDF)
  }

  generarPdf () {
    if (this.props.dataLiqMercaderiaFumigada) this.props.generarDetallesPdf()
  }

  parseData (data) {
    const parsedData = []
    if (data !== null) {
      data.forEach(entry => {
        parsedData.push({ ...entry, detalle: entry })
      })
    }
    return parsedData
  }

  saveAllPdf (url, filename) {
    this.props.saveAllPdf()
    saveAs(url, filename)
  }

  async componentDidMount () {
    const data = []
    this.props.updateTablaDeCartasDePorteVetadas({
      columns: this.COLUMNS,
      data,
      title: 'Cartas de porte vetadas para el ingreso',
      isLoading: false,
      extraOptions: { print: true, filter: true, rowsPerPage: 50 }
    })
    this.props.obtenerCartasDePorteVetadas().then(data => {
      this.props.updateTablaDeCartasDePorteVetadas({ isLoading: true })
      console.log(this.props.dataCartaDePorteVetada)
      data = this.parseData(this.props.dataCartaDePorteVetada)
      const title = `Cartas de porte vetadas para el ingreso`
      this.props.updateTablaDeCartasDePorteVetadas({ isLoading: false, data, title })
    })
    if (this.props.versionLaridae === null) this.props.actualizarVersion()
    this.interval = setInterval(() => {
      this.props.obtenerCartasDePorteVetadas().then(data => {
        this.props.updateTablaDeCartasDePorteVetadas({ isLoading: true })
        console.log(this.props.dataCartaDePorteVetada)
        data = this.parseData(this.props.dataCartaDePorteVetada)
        const title = `Cartas de porte vetadas para el ingreso`
        this.props.updateTablaDeCartasDePorteVetadas({ isLoading: false, data, title })
      })
      console.log('Ejecutando actualizacion de datos...')
    }, INTERVALO)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  render () {
    return (
      <div className='stock-container'>
        <MuiTable id={TABLE_CARTAS_DE_PORTE_VETADAS} />
        <hr />
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    dataCartaDePorteVetada: state.cartaDePorte.dataCartaDePorteVetada,
    detalleCartaDePorteVetada: state.cartaDePorte.detalleCartaDePorteVetada,
    detalle: state.cartaDePorte.detalle,
    fileOk: state.cartaDePorte.fileOk,
    fileDetallePdfOk: state.cartaDePorte.fileDetallePdfOk,
    versionLaridae: state.utils.versionLaridae
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({
    form: FORM_CARTAS_DE_PORTE_VETADAS
  })(CartasDePorteVetadas)
)
